import { useSelector } from 'react-redux'
import { ROLES } from 'utils/constants'

const useScopes = () => {
  const me = useSelector((state) => state.app.me)
  const isAdmin = me?.role === ROLES.ADMIN
  const isDoctor = me?.role === ROLES.DOCTOR
  const isCounselor = me?.role === ROLES.COUNSELOR

  return {isAdmin, isDoctor, isCounselor}
}

export default useScopes